module.exports = __webpack_public_path__ + "img/renmin.f3d6ca9f.png";